import React, { Fragment } from 'react'
import Layout from '../modules/Layout'
import Blocks from '../blocks/_Blocks'
import SEO from '../modules/Seo'

// TODO: data_source: '@root.content.collection' auflösen

const HomePage = ({ content, locale, name, alternates }) => {
  return (
    <div>
      <Layout locale={locale} alternates={alternates}>
        <SEO content={content} name={name} og_locale={locale} />
        {content.body &&
          content.body.map((block, index) => (
            <Fragment key={index}>
              {block.component === 'article_triple_teaser_block'
                ? React.createElement(Blocks(block.component), {
                    key: block._uid,
                    block: block,
                    xdata_source: '@root.content.collection',
                    data_limit: '3',
                    type: block.component,
                  })
                : React.createElement(Blocks(block.component), {
                    key: block._uid,
                    block: block,
                    type: block.component,
                  })}
            </Fragment>
          ))}
      </Layout>
    </div>
  )
}

export default HomePage
